(function ($, njm) {
    'use strict';

    njm.views.microBanner = Backbone.View.extend({

        /**
         * Initialize
         */
        initialize: function () {
            $('.scroll').click(function () {
                $('html,body').animate({
                    scrollTop: this.offsetTop + 50
                }, 1000);
            });
        }
    });
})(jQuery, njm);
